import React from 'react'
import { CalendarComponent } from './CalendarComponent'
import type { ProviderProps } from './Context'
import { Provider } from './Context'
import type { CalendarOptions } from '@fullcalendar/core'

export const FullCalendar = ({
  events,
  timeZone,
  setCalendarDate,
  components,
  ...rest
}: CalendarOptions & Omit<ProviderProps, 'children'>) => {
  return (
    <Provider {...{ events, timeZone, setCalendarDate, components, ...rest }}>
      <CalendarComponent />
    </Provider>
  )
}
